import delisted from "../../scripts/data/delisted-titles.json";

// Supplier product lines LoftLoom does not list (see scripts/data/delisted-titles.json
// for the reason behind each). They are dropped from every listing and search
// result, and their product pages are noindex. The Storefront API ignores
// negated title filters, so this has to happen in code.
const PATTERNS = delisted.titles.map((t) => t.toLowerCase());

export function isDelisted(title?: string | null): boolean {
  if (!title) return false;
  const t = title.toLowerCase();
  return PATTERNS.some((p) => t.includes(p));
}
